module.exports = __webpack_public_path__ + "static/img/tv.829fb9d8.svg";